module.exports = __webpack_public_path__ + "img/bg2.c4367859.jpg";